module.exports = __webpack_public_path__ + "assets/img/image_307.047c5754.png";